import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { Container, Image, Menu, Dropdown } from "semantic-ui-react";

class Navigation extends Component {
  componentDidMount() {
    const dropdop = document.querySelectorAll(".nav__dropdown");
    dropdop.forEach((item) =>
      item.addEventListener("click", function () {
        this.classList.toggle("dropdown--expanded");
      })
    );

    const collapsibles = document.querySelectorAll(".collapsible");
    collapsibles.forEach((item) =>
      item.addEventListener("click", function () {
        this.classList.toggle("collapsible--expanded");
      })
    );
  }
  render() {
    const { user } = this.props;
    const logoUrl = process.env.REACT_APP_URL + "/new_theme/gondalgroup.png";
    const spriteUrl = process.env.REACT_APP_URL + "/sprite.svg#menu";

    return (
      <nav class="nav nav--primary collapsible">
        <a href="/" class="nav__brand">
          <img src={logoUrl} alt="" />
        </a>
        <svg class="icon icon--white nav__toggler">
          <use href={spriteUrl}></use>
        </svg>
        <ul class="list nav__list collapsible__content">
          <li class="nav__item">
            <NavLink to="/dashboard">Dashboard</NavLink>
          </li>

          {user &&
            user.role === "client" &&
            user.client != "Alpha Private School" &&
            user.client != "Gondalism" &&
            user.client != "CodeWithBubby" && (
              <li class="nav__item">
                <NavLink to="/companies">Companies</NavLink>
              </li>
            )}

          <li class="nav__item nav__dropdown">
            {/* <a href="#">Store</a> */}
            <NavLink to="/categories">Store</NavLink>
            {/* <ul class="list nav__sublist">
              <li class="nav__subitem">
                <NavLink to="/categories">Categories</NavLink>
              </li>

              <li class="nav__subitem">
                <NavLink to="/items">Items</NavLink>
              </li>
            </ul> */}
          </li>

          {user &&
            user.role === "salary-admin" &&
            user.client != "Alpha Private School" &&
            user.client != "Gondalism" &&
            user.client != "CodeWithBubby" && (
              <React.Fragment>
                <li class="nav__item">
                  <NavLink to="/salaries">Salaries</NavLink>
                </li>
                <li class="nav__item">
                  <NavLink to="/report/salary">Generate Salaries</NavLink>
                </li>
                <li class="nav__item nav__dropdown">
                  <a href="#">Reports</a>
                  <ul class="list nav__sublist">
                    <li class="nav__subitem">
                      <NavLink to="/report/project-salary">
                        Project Salaries
                      </NavLink>
                    </li>
                  </ul>
                </li>
              </React.Fragment>
            )}

          {user &&
            user.role === "client" &&
            user.client != "Alpha Private School" &&
            user.client != "Gondalism" &&
            user.client != "CodeWithBubby" && (
              <React.Fragment>
                <li class="nav__item">
                  <NavLink to="/invoices">Invoices</NavLink>
                </li>

                <li class="nav__item nav__dropdown">
                  <a href="#">Cheques</a>
                  <ul class="list nav__sublist">
                    <li class="nav__subitem">
                      <NavLink to="/pdc-cheques/received">
                        PDC Received Cheques
                      </NavLink>
                    </li>
                    <li class="nav__subitem">
                      <NavLink to="/pdc-cheques/paid">
                        PDC Issued Cheques
                      </NavLink>
                    </li>
                  </ul>
                </li>

                <li class="nav__item">
                  <NavLink to="/projects-accounts">Projects</NavLink>
                </li>

                {/* <li class="nav__item nav__dropdown">
                  <a href="#">Other Accounts</a>
                  <ul class="list nav__sublist">
                    <li class="nav__subitem">
                      <NavLink to="/ledgers-types">Ledger Types</NavLink>
                    </li>
                    <li class="nav__subitem">
                      <NavLink to="/accounts">Other Accounts</NavLink>
                    </li>
                  </ul>
                </li> */}

                <li class="nav__item nav__dropdown">
                  <a href="#">Accounts</a>
                  <ul class="list nav__sublist">
                    <li class="nav__subitem">
                      <NavLink to="/accounts">Other Accounts</NavLink>
                    </li>
                    {user && user.email === "info_user3@gondalgroup.com" && (
                      <li class="nav__subitem">
                        <NavLink to="/private-accounts">
                          Private Accounts
                        </NavLink>
                      </li>
                    )}
                  </ul>
                </li>
              </React.Fragment>
            )}

          {user && user.role === "client" && (
            <React.Fragment>
              <li class="nav__item">
                <NavLink to="/general-ledger-entry">General Ledger</NavLink>
              </li>
              <li class="nav__item">
                <NavLink to="/reports">Reports</NavLink>
              </li>
            </React.Fragment>
          )}

          {user &&
            (user.role === "company" || user.role === "admin") &&
            user.client != "Alpha Private School" &&
            user.client != "Gondalism" &&
            user.client != "CodeWithBubby" && (
              <React.Fragment>
                <li class="nav__item nav__dropdown">
                  <a href="#">Rooms</a>
                  <ul class="list nav__sublist">
                    <li class="nav__subitem">
                      <NavLink to="/rooms-ledgers-types">Ledger Types</NavLink>
                    </li>
                    <li class="nav__subitem">
                      <NavLink to="/rooms-accounts">Accounts</NavLink>
                    </li>
                  </ul>
                </li>

                <li class="nav__item nav__dropdown">
                  <a href="#">Vehicles</a>
                  <ul class="list nav__sublist">
                    <li class="nav__subitem">
                      <NavLink to="/vehicles-ledgers-types">
                        Ledger Types
                      </NavLink>
                    </li>
                    <li class="nav__subitem">
                      <NavLink to="/vehicles-accounts">Accounts</NavLink>
                    </li>
                  </ul>
                </li>

                <li class="nav__item nav__dropdown">
                  <a href="#">Visas</a>
                  <ul class="list nav__sublist">
                    <li class="nav__subitem">
                      <NavLink to="/visas-ledgers-types">Ledger Types</NavLink>
                    </li>
                    <li class="nav__subitem">
                      <NavLink to="/visas-accounts">Accounts</NavLink>
                    </li>
                  </ul>
                </li>

                <li class="nav__item nav__dropdown">
                  <a href="#">Yards</a>
                  <ul class="list nav__sublist">
                    <li class="nav__subitem">
                      <NavLink to="/yards-ledgers-types">Ledger Types</NavLink>
                    </li>
                    <li class="nav__subitem">
                      <NavLink to="/yards-accounts">Accounts</NavLink>
                    </li>
                  </ul>
                </li>

                <li class="nav__item nav__dropdown">
                  <a href="#">Expenses</a>
                  <ul class="list nav__sublist">
                    <li class="nav__subitem">
                      <NavLink to="/expense-types">Expense Types</NavLink>
                    </li>
                    <li class="nav__subitem">
                      <NavLink to="/expenses">Expenses</NavLink>
                    </li>
                  </ul>
                </li>
              </React.Fragment>
            )}

          {user &&
            (user.role === "company" || user.role === "admin") &&
            user.client != "Alpha Private School" &&
            user.client != "Gondalism" &&
            user.client != "CodeWithBubby" && (
              <li class="nav__item nav__dropdown">
                <a href="#">More</a>
                <ul class="list nav__sublist">
                  {user.role === "company" && (
                    <li class="nav__subitem">
                      <NavLink to="/users">Users</NavLink>
                    </li>
                  )}

                  <li class="nav__subitem">
                    <NavLink to="/banks-accounts">Bank Details</NavLink>
                  </li>

                  <li class="nav__subitem">
                    <NavLink to="/company-documents">Documents</NavLink>
                  </li>
                </ul>
              </li>
            )}

          {user && (
            <React.Fragment>
              <li class="nav__item">
                <NavLink to="/logout">Logout</NavLink>
              </li>
              <li className="nav__item">
                <NavLink to="#" className="current-account">
                  {user.company}
                </NavLink>
              </li>
            </React.Fragment>
          )}
        </ul>
      </nav>
    );
  }
}

export default Navigation;
